PathLayer = require './path-layer'
toLatLng = require 'computeds/to-lat-lng'

module.exports = App.PointPathLayerComponent = PathLayer.extend
  leafletRequiredOptions: [ 'location' ]
  leafletProperties: [ 'location:setLatLng' ]
  location: toLatLng()